import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import LocationField from '../create/LocationField';
import ContactField from './ContactField';

class LocationDetails extends Component {
  handleFieldChange = (field) => this.props.onChange(field);
  handleAddContact = () => this.props.onAddContact();
  handleRemoveContact = (i) => () => this.props.onRemoveContact(i);

  handleContactFieldChange = (i) => (field, value) => {
    this.props.onContactFieldChange(i, field, value);
  };

  handleLocationAddressSelect = (item) => {
    this.props.onAddressChange(item.address);
  };

  renderLocationFields() {
    const { errors, action_type, name, address, t } = this.props;

    return (
      <div>
        <div>
          <fieldset className="md:mr-2">
            <label className="form-label block mb-2">
              {titleize(t('ACTION'))}
            </label>
            <select
              className="form-select mb-4"
              value={action_type.toLowerCase()}
              onChange={this.handleFieldChange('action_type')}
            >
              <option value="pickup">{titleize(t('PICKUP'))}</option>
              <option value="deliver">{titleize(t('DELIVERY'))}</option>
              <option value="pickup_empty">
                {titleize(t('PICKUP_EMPTY'))}
              </option>
              <option value="deliver_empty">
                {titleize(t('DELIVERY_EMPTY'))}
              </option>
            </select>
          </fieldset>
        </div>
        <div>
          <div className="w-full">
            <fieldset className="md:mr-2">
              <label className="form-label mb-2 block">{t('NAME')}</label>
              <input
                id={this.props.locationNameId}
                className="form-field mb-4 w-full block"
                value={name}
                placeholder={t('NAME')}
                onChange={this.handleFieldChange('name')}
              />
            </fieldset>
          </div>
          <div className="w-full">
            <fieldset className="md:mr-2 mb-4">
              <LocationField
                locationAddressId={this.props.locationAddressId}
                key={address}
                onAddressSelect={this.handleLocationAddressSelect}
                error={errors.hasOwnProperty('address')}
                address={address}
              />
            </fieldset>
          </div>
          <div className="w-full">
            {this.renderContacts()}
            <button
              className="mb-4 button button-hollow-green"
              onClick={this.handleAddContact}
            >
              <i className="fa fa-plus mr-2" />
              <span>{titleize(t('CONTACT', { count: 1 }))}</span>
            </button>
          </div>
        </div>
      </div>
    );
  }

  renderContacts() {
    const { contacts, t } = this.props;
    return (
      <div className="contacts mb-4">
        <label className="mb-2 form-label">
          {titleize(t('CONTACT', { count: 2 }))}
        </label>
        {contacts.map((contact, i) => (
          <ContactField
            contact={contact}
            key={i}
            onChange={this.handleContactFieldChange(i)}
            onRemove={this.handleRemoveContact(i)}
          />
        ))}
      </div>
    );
  }

  render() {
    const { sectionTitle } = this.props;
    return (
      <section className="mb-4">
        <h4 className="text-grey-dark">{sectionTitle}</h4>
        {this.renderLocationFields()}
      </section>
    );
  }
}

LocationDetails.propTypes = {
  locationNameId: PropTypes.string,
  locationAddressId: PropTypes.string,
  sectionTitle: PropTypes.string,
  action_type: PropTypes.string,
  name: PropTypes.string,
  errors: PropTypes.object,
  address: PropTypes.string,
  contacts: PropTypes.array,
  onAddressChange: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onContactFieldChange: PropTypes.func.isRequired,
  onAddContact: PropTypes.func.isRequired,
  onRemoveContact: PropTypes.func.isRequired,
};

LocationDetails.defaultProps = {
  errors: {},
};

export default withTranslation()(LocationDetails);

